import { Injectable } from '@angular/core';

const ACCESS_TOKEN_KEY = 'kc-ol.access-token';
const EXPIRY_KEY = 'kc-ol.access-token-expiry';

/**
 * Persistance de l'access token (sessionStorage : survit au rechargement, pas à la fermeture
 * de l'onglet).
 *
 * @remarks
 * Le refresh token, lui, n'est JAMAIS stocké ni lisible ici : c'est un cookie HttpOnly émis
 * par le domaine de Front, transporté automatiquement par `withCredentials: true`.
 */
@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  /** L'access token persisté, ou `null`. */
  public readAccessToken(): string | null {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
  }

  /** La date d'expiration persistée, ou `null`. */
  public readExpiry(): Date | null {
    const raw = sessionStorage.getItem(EXPIRY_KEY);
    return raw ? new Date(raw) : null;
  }

  /** Persiste le jeton et son expiration. */
  public write(accessToken: string, expiry: Date): void {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    sessionStorage.setItem(EXPIRY_KEY, expiry.toISOString());
  }

  /** Purge le jeton persisté. */
  public clear(): void {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(EXPIRY_KEY);
  }
}
